import {createTimeline, Timeline} from "animejs";

export class SplashAnimations {
    public splashAnimationTimeline: Timeline | undefined;
    public splashAnimationResolveCallback: ((value: number) => void) | null = null;
    public nameTextEl: HTMLElement | null = null;
    public titleTextEl: HTMLElement | null = null;
    public splashLogoEl: SVGElement | null = null;
    public startBtnEl: HTMLElement | null = null;
    
    public initSplashAnimation(options: object): void {
        this.splashAnimationTimeline = createTimeline({
            autoplay: false,
            onComplete: self => {
                if (this.splashAnimationResolveCallback) {
                    this.splashAnimationResolveCallback(self.currentTime);
                    this.splashAnimationResolveCallback = null;
                }
            }
        });
        this.nameTextEl = document.getElementById("NameText");
        this.titleTextEl = document.getElementById("TitleText");
        this.splashLogoEl = document.querySelector(".splash-logo-w");
        this.startBtnEl = document.querySelector(".splash-btn");
        
        if (this.nameTextEl && this.titleTextEl && this.startBtnEl && this.splashLogoEl) {
            this.splashAnimationTimeline
                .add("#NameText", {
                    translateX: -(this.nameTextEl.getBoundingClientRect().left + this.nameTextEl.offsetWidth),
                    duration: 600,
                    ease: "inOutQuad"
                })
                .add("#TitleText", {
                    translateX: window.innerWidth - this.titleTextEl.getBoundingClientRect().left, // Move it completely out to the right
                    duration: 500,
                    ease: "inOutQuad"
                }, 400)
                .add(".splash-btn", {
                    translateY: window.innerHeight - this.startBtnEl.getBoundingClientRect().top + this.startBtnEl.offsetHeight, // Move completely out of the viewport downward
                    duration: 500,
                    ease: "inOutQuad",
                }, 800)
                .add(".splash-logo-w", {
                    scale: 0, // Scale the logo to 0
                    duration: 500,
                    easing: "easeInOutQuad",
                    begin: () => {
                        // Ensure scaling happens relative to the center of the element
                        if (this.splashLogoEl) {
                            this.splashLogoEl.style.transformOrigin = "center center";
                        }
                    }
                }, 1200);
        }
    }
    
    public playSplashAnimation(): Promise<number> {
        if (this.splashAnimationTimeline) {
            return new Promise<number>((resolve) => {
                this.splashAnimationResolveCallback = resolve;
                this.splashAnimationTimeline?.play();
            });
        }
        
        return Promise.resolve(-1);
    }
}